<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createWorkflow" class="row">
              <div class="col-md-5 ">
                <h5>Information</h5>
                <br>
                <active-form-checkbox label="Active" name="active" v-model="workflow.active"></active-form-checkbox>
                <critical-form-checkbox label="Critical" name="critical" v-model="workflow.critical"></critical-form-checkbox>
                <endtimebased-form-checkbox label="End Time Based" name="endtimebased" v-model="workflow.endtimebased"></endtimebased-form-checkbox>       
                <br>
                <form-text ref="name" label="Name" name="name" v-model="workflow.name" validation="required"></form-text>
                <form-textarea label="Description" name="description" v-model="workflow.description"></form-textarea>
                <br>
                <h5>Warn Before</h5>
                <p>* Give a minute value for how long before this workflow is due that there should be a warning (if this isn't set, it will use device settings)</p>
                <form-textnumber ref="warnbefore" label="Warn Before" name="warnbefore" v-model="workflow.warnBefore" validation="numeric"></form-textnumber>
                <br>
                <h5>Schedule</h5>
                <p>* Give a minute value for how often the workflow should be completed. (Ex: input 60 for an hour)</p>
                <form-textnumber ref="schedule" label="Schedule" name="schedule" v-model="workflow.schedule" validation="required"></form-textnumber>
                <br>
                <br>
                <!--
                <h5>Mobile Devices</h5>
                <p>* These mobile devices are allowed to complete this workflow and will get notifications.</p>
                <br>
                <v-select placeholder="Assigned Mobile Devices" multiple :options="allDevices" label="name" name="devices" :value.sync="devices"></v-select>
                <br>
                <br> 
                <br> -->
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
              <div class="col-md-5 offset-md-1">
                <h5>Tasks</h5>
                <p>* Click and drag tasks to reorder</p>
                <div v-if="org['curOrg']['role'] == 99">
                  <button v-on:click="tasksJsonView = true" type="button" v-if="!tasksJsonView" class="btn btn-default">JSON View</button>
                  <button v-on:click="tasksJsonView = false" type="button" v-else class="btn btn-default">Normal View</button>
                </div>
                <br>

                <br>

                <p>{{tasks.length}} Tasks</p>
                <div v-if="!tasksJsonView">
                  <draggable :list="tasks" @end="reOrderTask">
                      <div class="list-group" v-for="task in tasks">
                        <div class = "list-group-item" v-for="element in task">
                          <div v-if="element.name == 'Location Tag'">
                            <div class="d-flex w-100 justify-content-between">
                              <p style="font-size:15px">{{element.name}}</p>
                              <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                            </div>
                            <small>Speak Text: {{element.speak}}</small>
                            <br>
                            <small class="">Tag Name: {{element.description}}</small>
                          </div>
                          <div v-else-if="element.name == 'Input'">
                            <div class="d-flex w-100 justify-content-between">
                              <p style="font-size:15px">{{element.name}}</p>
                              <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                            </div>
                            <small>Type: {{inputTypes.find(function(inputType){return inputType['.key'] == element.type})['name']}}</small>
                            <br>
                            <small class="">Name: {{element.description}}</small>
                          </div>
                          <div v-else-if="element.name == 'Temperature'">
                            <div class="d-flex w-100 justify-content-between">
                              <p style="font-size:15px">{{element.name}}</p>
                              <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                            </div>
                            <small class="">Name: {{element.description}}</small>
                          </div>
                        </div>
                      </div>
                  </draggable>
                </div>
                <div v-else>
                  <pre>{{ tasks | pretty }}</pre>
                </div>
                <br>
                <button type="button" data-toggle="modal" data-target="#createTaskModal" class="btn btn-success">Add Task</button>
                <button  v-if="org['curOrg']['role'] == 99" type="button" data-toggle="modal" data-target="#addJsonTasksModal" class="btn btn-default">Add JSON Tasks</button>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
    <createtask @addTask="addTask" name="createTaskModal"></createtask>
    <addjsontasks @addJsonTasks="addJsonTasks" name="addJsonTasksModal"></addjsontasks>

  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextNumber from '../../elements/Form/FormTextNumber'
import FormTextArea from '../../elements/Form/FormTextArea'
import draggable from 'vuedraggable'
import ActiveFormCheckbox from '../../elements/Form/ActiveFormCheckbox'
import CriticalFormCheckbox from '../../elements/Form/CriticalFormCheckbox'
import EndTimeBasedFormCheckbox from '../../elements/Form/EndTimeBasedFormCheckbox'
import CreateTaskModal from './Tasks/CreateTaskModal'
import AddJsonTasksModal from './Tasks/AddJsonTasksModal'
import LocationTag from './Tasks/LocationTag'
import database from '../../webmaster/Database/database'
import vSelect from 'vue-select'
import firebase from 'firebase'
import store from '../../webmaster/Store/vuex'
Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createworkflow',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea,
    draggable,
    'active-form-checkbox':ActiveFormCheckbox,
    'critical-form-checkbox':CriticalFormCheckbox,
    'endtimebased-form-checkbox':EndTimeBasedFormCheckbox,
    'locationtag': LocationTag,
    'createtask': CreateTaskModal,
    'addjsontasks': AddJsonTasksModal,
    'form-textnumber':FormTextNumber,
    vSelect
  },
  data () {
    return {
      org: store.state.usermain,
        workflow: {
          name: '',
          active: true,
          critical : true,
          endtimebased: true,
          description: '',
          schedule: '',
          warnBefore: '',
        },
        tasks:[],
        completions:[],
        devices: [],
        allDevices: [],
        tasksJsonView: false,

        inputTypes: [{'name': "Number", '.key': "number"}, {'name': "Text", '.key': "text"}, {'name': "True/False", '.key': "bool"}],
    }
  },
  created:function(){
    //Populate devices
    //var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/devices'
    //this.$bindAsArray('allDevices', database.getRef(ref).orderByChild('type').equalTo('Mobile Device'));
  },
  methods: {
    createWorkflow:function(e){
      e.preventDefault()
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => {

        if (self.tasks.length < 1) {
          return;
        }

        var workflowDevices = {}
        for (var device in self.devices) {
            var obj = self.devices[device];
            workflowDevices[obj['.key']] ={
              empty: "empty"
            }
        }
        var tasks = {}
        var completions = {}
        var count = 1
        for (var task in self.tasks) {
            var obj = self.tasks[task];
            tasks[count]=obj
            count++
        }
        var workflow = {
          name: self.workflow.name,
          active: self.workflow.active,
          critical: self.workflow.critical,
          endtimebased: self.workflow.endtimebased,
          description: self.workflow.description,
          schedule: self.workflow.schedule,
          warnBefore: self.workflow.warnBefore,
          devices:workflowDevices,
          tasks: tasks,
          completions:completions,
          lastcompleted: '',
          nextdue: Date.now() / 1000 | 0,
        }

        var meta_workflow = {
          name: self.workflow.name,
          active: self.workflow.active,
          critical: self.workflow.critical,
          endtimebased: self.workflow.endtimebased,
          description: self.workflow.description,
          schedule: self.workflow.schedule,
          warnBefore: self.workflow.warnBefore,
          devices: workflowDevices,
          tasks: tasks,
          lastcompleted: '',
          nextdue: Date.now() / 1000 | 0,
        }
        var curOrgId = self.$store.state.usermain.curOrg.id
        var newWorkflowKey = database.getDb().ref().child('orgs').child(curOrgId).child('workflows').push().key;
        var updates = {};
        updates['/orgs/' + curOrgId + '/workflows/' + newWorkflowKey] = workflow;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + newWorkflowKey] = meta_workflow;
        database.getDb().ref().update(updates, function(){
          self.$router.push('/operations/workflows')
        });
      }, () => {});
    },
    deleteTask:function(task){
      console.log(task)
      console.log(this.tasks)
    },
    addTask:function(task){
      this.tasks.push(task)
    },
    addJsonTasks:function(parsedTasks){
      parsedTasks.forEach(task => this.tasks.push(task))
    },
    reOrderTask:function(){
      //console.log(this.tasks)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// CreateWorkflow.vue?41239136